import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { url } from '../../config/global';
import { message } from 'antd';

export default function Sso() {
    const history = useHistory();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const fallbackRedirect = "/user";

        if (!token) return;

        fetch(`${url}/getSsoData/${token}`)
        .then((res) => {
          if (!res.ok) throw new Error("SSO data fetch failed");
          return res.json();
        })
        .then((data) => {
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("fullname", data.user.full_name);
          sessionStorage.setItem("avatar", data.user.avatar);
          sessionStorage.setItem("permissions", JSON.stringify(data.permissions || []));
          sessionStorage.setItem("redirect", data.redirect || fallbackRedirect);
          sessionStorage.setItem("_id", data.user._id);

          message.success("Login via SSO berhasil!");

          if (data.user?.role_name?.toLowerCase() === "security") {
            history.push("/security-control");
          } else {
            history.push(data.redirect || fallbackRedirect);
          }
        })
        .catch((err) => {
          console.error("Failed to load SSO data:", err);
          message.error("Gagal memuat data SSO.");
        })
    }, [history]);

    return null;
}